module.exports = __webpack_public_path__ + "static/applicationRating-ab154bf40ecb81b2447422ef27b9d0ec.svg";